import MergeProfilePopover from '/component/partial/MergeProfilePopover/MergeProfilePopover';

export const generateOpenMergePopover = (
  {popoverShow}: any,
  handleMergeProfile: any,
) => {
  return () => {
    popoverShow(MergeProfilePopover, {
      onSubmit: () => handleMergeProfile,
    });
  };
};
